import { Button, ButtonProps } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { clsx } from 'clsx';
import React from 'react';

import { Loader } from '@components/Loader';

interface Props {
  className?: string;
  extraPadding?: boolean;
  outlined?: boolean;
  disabled?: boolean;
  counter?: number;
  loading?: boolean;
  green?: boolean;
}

export const BlueButton = (props: ButtonProps & Props) => {
  const { className, extraPadding, outlined, counter, loading, green, ...restProps } = props;
  const cls = useStyles();

  return (
    <Button
      className={clsx(
        cls.btn,
        outlined && cls.outlined,
        extraPadding && cls.extraPadding,
        green && cls.green,
        className,
      )}
      variant={outlined ? 'outlined' : 'contained'}
      color="secondary"
      {...restProps}
    >
      {loading && <Loader mini className={cls.loader} />}
      {props.children}
      {counter && counter > 0 ? (<span className={cls.counter}>{counter}</span>) : null}
    </Button>
  );
};


const useStyles = makeStyles({
  btn: {
    position: 'relative',
    fontFamily: 'var(--font-primary);',
    fontSize: 14,
    fontWeight: 400,
    borderRadius: 8,
    textTransform: 'none',
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: 'center',
    color: 'var(--primary-button-color)',
    backgroundColor: 'var(--primary-color)',

    '&:hover': {
      color: 'var(--primary-button-color)',
      backgroundColor: 'var(--primary-color)',
    },

    '& svg': {
      display: 'inline-block',
      marginRight: 8,
    },
  },
  loader: {
    position: 'absolute',
    left: 4,
    top: 8,
  },
  extraPadding: {
    paddingLeft: 60,
    paddingRight: 60,
  },
  outlined: {
    border: '1px solid var(--primary-color)',
  },
  counter: {
    backgroundColor: 'var(--foreground-color)',
    width: 23,
    height: 23,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'var(--text-color)',
    fontSize: 13,
    marginLeft: 7,
  },
  green: {
    backgroundColor: '#005F3A !important',
  },
});
